<template>
  <section id="question" class="big spacer half">
    <div class="title">{{ $t("question") }}</div>
    <form
      id="aha-form"
      v-if="!submitted"
      action="https://send.pageclip.co/SZzQs2FEnDCpvSPoEocdmSzVG81GR9gG"
      class="pageclip-form"
      method="post"
    >
      <input
        type="text"
        name="Fragen"
        class="big"
        placeholder="..."
        v-model="question"
      />
      <button class="pageclip-form__submit big" type="submit">
        <template v-if="this.$i18n.locale == 'en'">&rarr; Send</template>
        <template v-else>&rarr; Senden</template>
      </button>
    </form>
  </section>
</template>

<script>
export default {
  data() {
    return {
      submitted: false,
      question: []
    };
  }
};
</script>

<style lang="scss" scoped>
input {
  border: 0;
  width: 100%;
  font-family: "PlainMedium", sans-serif;
  border: 0;
  padding: 0;
  // height: var(--fs);
  padding-top: var(--lh);
  padding-bottom: var(--lh);
  border-bottom: var(--b) solid var(--color);
  appearance: none;
  color: var(--color);
  background: transparent;
  border-radius: 0;
  &::placeholder {
    color: var(--hover);
  }
  &:focus {
    outline: none;
  }
}

button {
  border: 0;
  background: transparent;
  text-align: left;
  padding: 0;
  font-family: "PlainMedium", sans-serif;
  padding-top: var(--lh);
  color:var(--color);
  // height: calc(5.5 * var(--fs));
  padding-bottom: 0;
  cursor: pointer;
  width: auto;
  border-bottom: var(--b) solid transparent;
  &:hover {
    border-bottom: var(--b) solid var(--color);
  }
  &:focus {
    outline: none;
  }
}
</style>
